import script from "./TimesUpModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimesUpModal.vue?vue&type=script&setup=true&lang=ts"

import "./TimesUpModal.vue?vue&type=style&index=0&id=d4ca1b24&lang=scss"

const __exports__ = script;

export default __exports__